import type { FormConfig } from '#types/config/components/vf/form'

export default {
  brandClasses: {
    inputText: 'text-xs',
    selectText: 'text-xs ml-3'
  }
} satisfies FormConfig['label']
